export default __webpack_public_path__ + "static/confetti-animation-c6107dceeec1e8206396658dee2c4e6a.gif";